/***
 * 公共方法
 */

const misc = {};

/***
 * 获取当前操作的会议
 * @param that
 * @param meetingId
 * @param callback
 */
misc.manipulateMeetingId = function (that, meetingId, callback) {
    if (meetingId) {
        callback(meetingId);
    } else {
        let roomNo = that.$store.state.app.meetingRoomNo;
        let meetingId = localStorage.getItem("currentMeetingId");
        that.$app.post("/meeting/getCurentMeeting", { roomNo, meetingId }).then(res => {
            if (res.data.code == 0) {
                callback(res.data.data.pkid);
            } else{
                callback(0);
            }
        });
    }
}

// 获取当前进行中的会议
misc.getMeetingByRoom = function (that, roomNo, callback) {
  that.$app.post("/meeting/getMeetingByRoom",{roomNo: roomNo}).then(res => {
    if (res.data.code == 0) {
      callback(res.data.data);
    }
  });
}


/**
 * Created with IntelliJ IDEA.
 * Description: 获取默认议题类型
 * @Author:chenjiacheng
 * @Date:2018/11/10 10:08
 * @param null
 * @return
 */
misc.defaultTopicType = function (that, callback) {

    that.$app.post("/topicType/defaultCascader").then(res => {
        callback(res.data.data);
    });

}

/**
 * Created with IntelliJ IDEA.
 * Description: 获取排序最大值
 * @Author:chenjiacheng
 * @Date:2018/11/22 16:03
 */
misc.getMaxSort = function (that, path, params, callback) {

    that.$app.post(path, params).then(res => {
        callback(res.data.data);
    });

}
/**
 * Created with Visual Studio Code.
 * Description:  从对象中抽取部分属性组成新的对象.
 * @Author:luzhijing
 * @Date:2018/11/22 16:03
 */
// 从对象中过滤出指定的值
misc.getTargetObject = (targetObject, propsArray) => {
    if (typeof (targetObject) !== "object" || !Array.isArray(propsArray)) {
        throw new Error("参数格式不正确");
    }
    const result = {};
    Object.keys(targetObject).filter(key => propsArray.includes(key)).forEach(key => {
        result[key] = targetObject[key];
    })
    return result;
}

/**
 * Created with IntelliJ IDEA.
 * Description: 获取会议室列表
 * @Author:chenjiacheng
 * @Date:2018/12/11 17:01
 */
misc.findBoardRoomAll = (that, callback) => {

    that.$app.post("/boardroom/list",{
        statuses: [JSON.parse(sessionStorage.getItem('emums')).boardRoomStatus.enabled],
    }).then(res => {
        callback(res.data);
    });
}

/**
 * Created with IntelliJ IDEA.
 * Description: 获取当前操作的会议室
 * @Author:chenjiacheng
 * @Date:2018/12/11 17:01
 */
misc.findCurrBoardRoom = (that, callback) => {
    let roomNo = that.$store.state.app.meetingRoomNo;
    that.$app.post("/boardroom/findCurrBoardRoom", { roomNo }).then(res => {
        callback(res.data);
    });

}

/**
 * Created with IntelliJ IDEA.
 * Description: 修改当前操作的会议室
 * @Author:chenjiacheng
 * @Date:2018/12/11 17:01
 */
misc.editCurrBoardRoom = (that,roomId, roomNo, callback) => {
    if (!roomNo) {
        roomNo = that.$store.state.app.meetingRoomNo;
    }
    that.$app.post("/boardroom/editCurrBoardRoom", { "roomId":roomId, "roomNo": roomNo }).then(res => {
        localStorage.setItem("layoutBackgroundPath", res.data.data.layoutBackgroundPath);
        callback(res.data);
    });

}


/**
 * Created with IntelliJ IDEA.
 * Description: 获取当前操作的会议室的websocket
 * @Author:chenjiacheng
 * @Date:2018年12月20日 18点39分
 */
misc.getSocketInfo = (that, callback) => {
    that.$app.post("/webSocket/default",{}).then(res => {
        callback(res.data);
    });

}

misc.getEnums = (that, callback) => {

  that.$app.post("/system/enums").then(res => {
    callback(res.data);
  });

}
// 验证安全扫描是否可以删除
misc.checkMqttScanSafe = (that,scanSafeIds,callback) => {
    that.$app.post("/klk/checkMqttScanSafe",{ 'scanSafeIds':scanSafeIds }).then(res => {
        callback(res);
    });
}
// 通知客户端
misc.sendMqttNotice = (that,param,callback) => {
    that.$app.post("mqtt/controlByCommandEnum", param).then(res => {
        // if (res.data.code == 0) {
            callback(res.data);
            // console.log("已通知客户端应用场景")
        // }
    })
},

// 别名白名单
misc.dealWithWhiteBorrowNode = (that,params,callback) =>{
    that.$app.post("klk/dealWithWhiteBorrowNode",params).then(res => {
        callback(res.data);
    })
}
/**
 * Created with IntelliJ IDEA.
 * Description: 平板系统的密级公共方法
 * @Author:yangfh
 * @Date:2018/12/11 17:01
 */
// 关闭涉密设置
misc.closeConfidentiality = (nameFlag,type,refsSon) => {
    var that = this
    nameFlag.isOpen = false;
    var paramsData = refsSon
    paramsData.setTaskLock = nameFlag.setTaskLock;
    // 截屏
    paramsData.setScreenCaptureDisabled = nameFlag.setScreenCaptureDisabled;
    // 导航栏
    paramsData.setNavigationBarDisabled = nameFlag.setNavigationBarDisabled;
    // 任务键
    paramsData.setTaskButtonDisabled = nameFlag.setTaskButtonDisabled;
    // Home键
    paramsData.setHomeButtonDisabled = nameFlag.setHomeButtonDisabled;
    // 关机键进入关机界面
    paramsData.setPowerDisabled = nameFlag.setPowerDisabled;
    // 悬浮球
    paramsData.setFloatTaskDisabled = nameFlag.setFloatTaskDisabled;
    // 电源键休眠
    paramsData.setSleepByPowerButtonDisabled = nameFlag.setSleepByPowerButtonDisabled;
    // USB
    paramsData.setUSBDataDisabled = nameFlag.setUSBDataDisabled;
    // 返回键
    paramsData.setBackButtonDisabled = nameFlag.setBackButtonDisabled;
    // 顶部状态栏
    paramsData.setStatusBarDisabled = nameFlag.setStatusBarDisabled;
    // 顶部控制中心
    paramsData.setStatusBarExpandPanelDisabled = nameFlag.setStatusBarExpandPanelDisabled;
    // 语音助手按键
    paramsData.setVoiceAssistantButtonDisabled = nameFlag.setVoiceAssistantButtonDisabled;
    // 多窗口功能
    paramsData.setMultiWindowDisabled = nameFlag.setMultiWindowDisabled;
    // 电源按键
    paramsData.enablePowerKey = nameFlag.enablePowerKey
    // 全屏
    paramsData.fullScreenForever =  nameFlag.fullScreenForever
    if(type == 'lenSettingFlag') {
      paramsData.enablePowerKey = nameFlag.enablePowerKey;
      paramsData.fullScreenForever = nameFlag.fullScreenForever;
    }
   return refsSon = paramsData;
  },
// 属于保密会议
misc.isConfidentiality = (settingFlag) => {

    var paramsData = settingFlag

    paramsData.isOpen = true;

    paramsData.setTaskLock = true;
    // 截屏
    paramsData.setScreenCaptureDisabled = false;
    // 导航栏
    paramsData.setNavigationBarDisabled = false;
    // 任务键
    paramsData.setTaskButtonDisabled = false;
    // Home键
    paramsData.setHomeButtonDisabled = false;
    // 关机键进入关机界面
    paramsData.setPowerDisabled = false;
    // 悬浮球
    paramsData.setFloatTaskDisabled = false;
    // 电源键休眠
    paramsData.setSleepByPowerButtonDisabled = false;
    // USB
    paramsData.setUSBDataDisabled = false;
    // 返回键
    paramsData.setBackButtonDisabled = false;
    // 顶部状态栏
    paramsData.setStatusBarDisabled = false;
    // 顶部控制中心
    paramsData.setStatusBarExpandPanelDisabled = false;
    // 语音助手按键
    paramsData.setVoiceAssistantButtonDisabled = false;
    // 多窗口功能
    paramsData.setMultiWindowDisabled = false;

    // 电源按键
    paramsData.enablePowerKey = false
        // 全屏
    paramsData.fullScreenForever = false

    return paramsData
},
    // 文件大小转换
misc.formatSize = (fileSize)  => {
    let sizes = ["B", "KB", "MB", "GB", "TB"];
    let i = 0;
    if (fileSize < 1024) {
        return fileSize.toFixed(2) + sizes[0];
    }
    while (fileSize / 1024 > 1) {
        fileSize = fileSize / 1024;
        i++;
    }
    return fileSize.toFixed(2) + sizes[i];
},
//英文字符限制
// misc.regEn = /[`~!@#$%^&*_+<>?:"{},.\/;'[\]]/im;
 misc.regEn = /["\\/']/im;

//中文字符限制
// misc.regCn = /[·！#￥——：；“”‘s、，|《。》？、【】[\]]/im;
misc.regCn = /[“”‘\\/]/im;
//字数的最大限制
misc.max =50;
//特殊字符验证
misc.validateInput=(rule, value, callback)=>{
    if(misc.regEn.test(value) || misc.regCn.test(value)) {
        return callback(new Error("包含特殊字符"));
    }else{
        return callback();
    }
}

// 验证包含html中特殊标签
misc.validateHtmlInput=(rule, value, callback)=>{
  if(/<(?=p|P|div|DIV|a|A|h|H|br|BR)/.test(value)) {
    return callback(new Error("包含网页的特殊字符标签"));
  }else{
    return callback();
  }
}
// 表情符号限制
misc.emoji = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/im;
// 验证包含表情符号
misc.validateEmoji=(rule, value, callback)=>{
  if(misc.emoji.test(value)) {
    return callback(new Error("禁止输入表情符号"));
  }else{
    return callback();
  }
}

//时间格式化
misc.formatDate = (date)=> {
    const y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let mi = date.getMinutes();
    mi = mi < 10 ? "0" + mi : mi;
    return y + "-" + m + "-" + d + " " + h + ":" + mi;
}

/**
 * @desc 防抖函数
 * @param {需要防抖的函数} func
 * @param {延迟时间} wait
 * @param {是否立即执行} immediate
 */
var waitTimeout = null //计时器
misc.debounce = (func, wait = 500, immediate = false) => {
    if (waitTimeout) clearTimeout(waitTimeout)//如果有计时器就清除计时器
    if (immediate) { //如果立即执行设置为true
        if (!waitTimeout) func()//执行函数
    } else {
        //立即执行为false就开个定时器在执行这个函数
        waitTimeout = setTimeout(function() {
            if (func) {
                func()
            }
        }, wait)
    }
}

/**
 * @desc 只触发第一次
 * @param {只触发第一次的函数} func
 * @param {延迟时间} wait
 */
var firstTriggerTimeout = null;  
  
misc.firstTrigger = (func, wait = 300) => {  
    if (!firstTriggerTimeout) {  
        // 执行函数  
        func();

        // 设置计时器，在 wait 时间后允许下一次的首次触发  
        firstTriggerTimeout = setTimeout(() => {  
            firstTriggerTimeout = null;  
        }, wait);  
    }  
}  

// 后台全局标识是否是标准版的，用于隐藏标准版不需要的模块
misc.isStandard = false;
/**
 * 登陆倒计时  默认2000ms
 * @author yhb
 * @date 2019/3/12
 */
misc.countdown =2000;
/**
 * 提醒激活码倒计时天数  默认7天
 * @author yhb
 * @date 2019/3/12
 */
misc.countday =7;
export default misc;



// WEBPACK FOOTER //
// ./src/libs/misc.js